import {
  MessageSquare,
  PlusCircle,
  FolderKanban,
  Bot,
  Users,
  Wrench,
  Workflow,
  ListTodo,
  BarChart3,
} from 'lucide-react';

/** Primary sidebar nav — matches existing sply-labs routes. */
export const NavData = [
  { path: 'chat', name: 'Dune Chat', icon: MessageSquare },
  { path: 'create-agent', name: 'Create Agent', icon: PlusCircle },
  { path: 'projects', name: 'Projects', icon: FolderKanban },
  { path: 'agents', name: 'Agents', icon: Bot },
  { path: 'team', name: 'Team', icon: Users },
  { path: 'tools', name: 'Tools', icon: Wrench },
  { path: 'workflows', name: 'Workflows', icon: Workflow },
  { path: 'task-manager', name: 'Task Manager', icon: ListTodo },
];

export const SecondaryNavData = [{ path: 'analytics', name: 'Analytics', icon: BarChart3 }];

/** Flatten nav items (including children) for route lookups. */
export const flattenNavData = (items = NavData) =>
  items.flatMap(item => (item.children ? [item, ...item.children] : [item]));
